if (!customElements.get('events-image-viewer')) {
  customElements.define('events-image-viewer', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      this.image = this.dialog.querySelector('img');
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-events-image]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        if (typeof this.dialog.showModal !== 'function') return;
        event.preventDefault();
        this.opener = link;
        this.image.src = link.href;
        this.image.alt = link.querySelector('img').alt;
        this.dialog.showModal();
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
      }, options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog || event.target.closest('[data-events-close]')) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        this.restoreScroll();
        this.image.removeAttribute('src');
        if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
      }, options);
    }

    restoreScroll() {
      if (this.previousOverflow === undefined) return;
      document.documentElement.style.overflow = this.previousOverflow;
      this.previousOverflow = undefined;
    }

    disconnectedCallback() {
      this.restoreScroll();
      this.controller?.abort();
      this.controller = null;
      this.dialog?.close();
    }
  });
}
